import template from './accountsList.template.html';
import templateAccountAdd from './accountDisable.template.html';
import templatePartnerAttributesEdit from './partnerAttributesEdit.template.html';

export default {
  template,
  bindings: {
    accounts: '=',
    showBrokerToggle: '=',
    onChangePartnersAttributes: '&',
    onAssignMentor: '&',
    onToggle: '&',
    onDisable: '&',
    onChange: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $filter,
      $timeout,
      $mdDialog,
      $mdMedia,
      uiService,
      listService,
      authenticationService,
      PartnerAttributes,
      GOOGLEMAPS,
      PARTNER,
      INSTANCE
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.list = listService;
      ctrl.isManager = authenticationService.isManager();
      ctrl.list.clear();

      ctrl.initialize = () => {
        ctrl.CurrentOrganization = $rootScope.CurrentOrganization;
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.accounts, ctrl.list.getGroupingByFirstLetter())
        );
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.toggle = ($event, data, type) => {
        if (!data.isOwner || type === 'mentor') {
          ctrl.onToggle({ event: $event, data, type });
        }
      };

      ctrl.disable = ($event, data, type) => {
        $timeout(() => {
          if (data.isDisabled === false) {
            if (!data.isOwner && !data.isManager) {
              ctrl.onToggle({ event: $event, data, type });
            }
          } else {
            $mdDialog
              .show({
                targetEvent: $event,
                locals: {
                  organizationName: $rootScope.CurrentOrganization.organization.name
                },
                template: templateAccountAdd,
                controllerAs: '$ctrl',
                controller(organizationName) {
                  const self = this;
                  self.organizationName = '';
                  self.account = data;
                  self.isOrganizationNameEqual = () => {
                    return (
                      self.organizationName.toLowerCase() === organizationName.toLowerCase()
                    );
                  };
                  self.confirm = () => {
                    $mdDialog.hide({ account: self.account, type });
                  };
                  self.cancel = () => {
                    self.account.isDisabled = false;
                    $mdDialog.cancel();
                  };
                }
              })
              .then((result) => {
                if (!result.account.isOwner && !result.account.isManager) {
                  ctrl.onToggle({ event: $event, data: result.account, type: result.type });
                }
              });
          }
        });
      };

      ctrl.select = (data) => {
        const isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data, isSelected });
      };

      ctrl.changePartnersAttributes = () => {
        ctrl.onChangePartnersAttributes({
          partnersAttributes: ctrl.CurrentOrganization.partnersAttributes
        });
      };

      ctrl.editPartnerAttributes = ($event, partner, partnersAttributes) => {
        $event.stopPropagation();
        $mdDialog
          .show({
            targetEvent: $event,
            locals: {},
            template: templatePartnerAttributesEdit,
            controllerAs: '$ctrl',
            controller() {
              const self = this;
              self.currency = $rootScope.CurrentCurrency;
              self.partnerTypes = PARTNER.TYPES;
              self.isUser = true;
              self.partner = partner;
              self.isGemNzInstance = INSTANCE.identification === 'GNZ';
              self.partnerAttributes = partnersAttributes
                ? PartnerAttributes.build(partnersAttributes)
                : PartnerAttributes.blank();

              self.googleAutocompleteOptions = {
                componentRestrictions: GOOGLEMAPS.restrictToCountries
              };
              self.confirm = () => {
                $mdDialog.hide(self.partnerAttributes);
              };

              self.cancel = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((partnerAttributes) => {
            ctrl.CurrentOrganization.partnersAttributes[partner.id] = partnerAttributes;
            ctrl.changePartnersAttributes();
          });
      };

      ctrl.getMentors = (mentee) => {
        const idMentors =
          $rootScope.CurrentOrganization.mentees &&
          $rootScope.CurrentOrganization.mentees[mentee.id]
            ? $rootScope.CurrentOrganization.mentees[mentee.id]
            : [];
        return _.filter(ctrl.accounts, (a) => idMentors.indexOf(a.id) > -1);
      };

      ctrl.assignMentors = ($event, account) => {
        $event.preventDefault();
        if (account.isOwner) {
          uiService.toast({
            text: {
              p1: account.getName(),
              p2: 'is the organization owner',
              p3: 'and cannot have a mentor'
            },
            warn: true
          });
        } else if (account.isMentor) {
          uiService.toast({
            text: {
              p1: account.getName(),
              p2: 'is a mentor',
              p3: 'and cannot have a mentor'
            },
            warn: true
          });
        } else {
          ctrl.onAssignMentor({ event: $event, currentMentee: account });
        }
      };

      ctrl.isOwner = () => authenticationService.isOwner();

      ctrl.$onInit = () => ctrl.initialize();

      ctrl.$onChanges = (changes) => {
        if (changes.accounts && changes.accounts.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
